import React, { Component } from 'react'
import * as mat from 'material-ui';
import FaCloudDownload from 'react-icons/lib/fa/cloud-download';
// import MdCloudUpload from 'react-icons/lib/md/cloud-upload';
// import gDrive from '../images/Google-Drive-Icon.png'
import { connect } from 'react-redux';
import dummy from '../images/Logo.jpg'
import Workbook from 'react-excel-workbook'
import { getResultAction, getResultSheet } from '../../action/resultAction';


class RESULTS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            loader: nextProps.Loading
        })
    }
    componentWillMount() {
        this.props.getResultAction()
    }
    DownloadXlsx(value) {
        // console.log(value,"value")
        this.props.getResultSheet(value)
    }
    render() {
        const {
            resultList,
            noList
        } = this.props
        // console.log(resultList,'resultList')
        // console.log(noList,'noResult')
        return (
            <div className='col-md-12 col-xs-12'>
                <div className="page-header text-center">
                    <h3>My Results</h3>
                </div>
                {(this.state.loader === false) ? (
                    <div>
                        {(noList === undefined) ? (
                            <mat.Table  >
                                <mat.TableHeader displaySelectAll={false} adjustForCheckbox={false} enableSelectAll={false}>
                                    <mat.TableRow >
                                        <mat.TableHeaderColumn>Date</mat.TableHeaderColumn>
                                        <mat.TableHeaderColumn>Quiz Name</mat.TableHeaderColumn>
                                        <mat.TableHeaderColumn>Quiz Type</mat.TableHeaderColumn>
                                        <mat.TableHeaderColumn>Options</mat.TableHeaderColumn>
                                    </mat.TableRow>
                                </mat.TableHeader>
                                <mat.TableBody displayRowCheckbox={false}>
                                    {resultList.map((v, i) => {
                                        return (
                                            <mat.TableRow key={i}>
                                                <mat.TableRowColumn>{new Date(v.playedOn).toLocaleString()}</mat.TableRowColumn>
                                                <mat.TableRowColumn>{v.quizName}</mat.TableRowColumn>
                                                <mat.TableRowColumn>{v.gameType}</mat.TableRowColumn>
                                                <mat.TableRowColumn>
                                                    <mat.RaisedButton
                                                        onClick={this.DownloadXlsx.bind(this, v)}
                                                        label='Download'
                                                        icon={<FaCloudDownload style={{ color: '#2699f4', fontSize: 20 }} />}
                                                    />


                                                    {/* <mat.RaisedButton
                                                          label='Save'
                                                           icon={<img src={gDrive} style={{ width: 20 }} alt='' />}
                                                         />  */}
                                                </mat.TableRowColumn>
                                            </mat.TableRow>
                                        )
                                    })}
                                </mat.TableBody>
                            </mat.Table>
                        ) : (
                                <div className='col-md-4 col-md-offset-4 text-center' style={{ marginTop: '10%' }}>
                                    <p style={{fontSize: 18}}><strong>{noList}</strong>...</p>
                                </div>
                            )}
                    </div>


                ) : (
                        <div className='col-md-4 col-md-offset-4 text-center' style={{ marginTop: '10%' }}>
                            <mat.CircularProgress thickness={6} size={50} color={'#4aa6ef'} />
                            <br />
                            <p ><strong>Wait For Loading</strong>...</p>
                        </div>
                    )}

            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        resultList: state.resultReducers.allResults,
        noList: state.resultReducers.noResult,
        Loading: state.resultReducers.loading
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        getResultAction: () => {
            dispatch(getResultAction())
        },
        getResultSheet: (value) => {
            dispatch(getResultSheet(value))
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(RESULTS);
// export default PLAYED;


// WEBPACK FOOTER //
// ./src/component/played/played.jsx